/**
 * Returns today's local calendar date encoded at UTC midnight.
 *
 * Native date inputs use YYYY-MM-DD values, which JavaScript parses as UTC.
 * Building the default the same way keeps the displayed day stable regardless
 * of the user's timezone.
 */
export const getTodayForDateInput = (): Date => {
  const now = new Date();
  return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
};
